import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../../../../../../../../emotion-theme";

export const HostContainer = styled.div`
  color: ${BASE_COLORS.grey};
`;
